import { render, staticRenderFns } from "./ApprovalDetailsDialog.vue?vue&type=template&id=30176a66"
import script from "./ApprovalDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetailsDialog.vue?vue&type=style&index=0&id=30176a66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports